import { createBrowserClient } from "@supabase/ssr";
export { productKey, productRoutePath } from "../lib/productRoute";

export const SHARED_AUTH_COOKIE_NAME = "ai-agent-offer-auth";
const LEGACY_AUTH_STORAGE_KEY = "ai-agent-offer.auth";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() ?? "";
const supabasePublishableKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() ?? "";

export const isSupabaseConfigured = Boolean(supabaseUrl && supabasePublishableKey);

export const supabase = isSupabaseConfigured
  ? createBrowserClient(supabaseUrl, supabasePublishableKey, {
      cookieOptions: {
        name: SHARED_AUTH_COOKIE_NAME,
        path: "/",
        sameSite: "lax",
      },
    })
  : null;

if (supabase && typeof window !== "undefined") {
  const legacySession = window.localStorage.getItem(LEGACY_AUTH_STORAGE_KEY);
  if (legacySession) {
    try {
      const parsed = JSON.parse(legacySession) as {
        access_token?: unknown;
        refresh_token?: unknown;
      };
      if (
        typeof parsed.access_token === "string" &&
        typeof parsed.refresh_token === "string"
      ) {
        void supabase.auth
          .setSession({
            access_token: parsed.access_token,
            refresh_token: parsed.refresh_token,
          })
          .then(({ error }) => {
            if (!error) window.localStorage.removeItem(LEGACY_AUTH_STORAGE_KEY);
          });
      }
    } catch {
      // An unreadable legacy value is ignored; normal cookie auth still works.
    }
  }
}
